const methods = {
    RESET_SESSION: () => ({ type: 'RESET_SESSION' })
}

export default methods